import { render, staticRenderFns } from "./warehouseBoxList.vue?vue&type=template&id=3b3bc66c&scoped=true&"
import script from "./warehouseBoxList.vue?vue&type=script&lang=js&"
export * from "./warehouseBoxList.vue?vue&type=script&lang=js&"
import style0 from "./warehouseBoxList.vue?vue&type=style&index=0&id=3b3bc66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bc66c",
  null
  
)

export default component.exports